import React, {useContext, useMemo} from "react";

// Components
import VideoContentGridLandscape from "../../Components/Layouts/Content/Watch/VideoFeed/VideoContentGridLandscape";
import ButtonPill from "../../Components/Buttons/ButtonPill";

// Hooks
import useFetchSpecificContentItems from "../../Hooks/Content/Watch/VideoSingle/useFetchSpecificContentItems";

// Context
import {GlobalInterfaceContext} from "../../Context/GlobalInterfaceContext";
import {UserAuthenticationContext} from "../../Context/UserAuthenticationContext";

// Constants
import {RoutePaths} from "../../Constants/RoutePaths";

const DavidIckeFilms = () => {
    const
        { isDarkMode } = useContext(GlobalInterfaceContext),
        authCtx = useContext(UserAuthenticationContext),

        // User data
        userId = authCtx.userData?.id ?? "1c624ef2-27a9-496f-b518-6f6e612078b6",
        countryCode = "GB",

        filmsIds = useMemo(
            () => [
                { type: "Film", id: 3070 },
                { type: "Film", id: 3080 },
                { type: "Series", id: 184 },
                { type: "Series", id: 178 },
                { type: "Film", id: 2688 },
                { type: "Film", id: 2242 },
                { type: "Film", id: 2201 },
                { type: "Film", id: 2220 },
                { type: "Film", id: 2190 },
                { type: "Film", id: 2072 },
                { type: "Film", id: 1568 },
                { type: "Film", id: 1386 },
                { type: "Film", id: 1026 },
                { type: "Series", id: 156 },
                { type: "Series", id: 155 },
                { type: "Film", id: 582 },
                { type: "Film", id: 40 },
                { type: "Film", id: 31 },
                { type: "Film", id: 26 },
            ],
            []
        ),
        {
            items,
            loading,
            error
        } = useFetchSpecificContentItems(filmsIds, countryCode, userId);


    return (
        <div className="page page--david-icke page--david-icke-sub-page">
            <div className="david-icke__banner">
                <img src="https://storage.ickonic.com/IckonicImage/compressed/David Icke Header 04b.jpg"
                     alt="David Icke - World Renowned Author and Researcher"/>
            </div>

            <div className="page__heading">
                <h1>
                    David Icke - All Films
                </h1>

                <ButtonPill label="Back" link={RoutePaths.DavidIcke}/>
            </div>

            <VideoContentGridLandscape
                isDarkMode={isDarkMode}
                carouselItems={loading ? undefined : items}
                backgroundHex="#151515"
            />
        </div>
    )
}

export default DavidIckeFilms;
